var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ConfigCatConsoleLogger } from "./ConfigCatLogger";
import { LogLevel } from "./index";
import { InMemoryCache } from "./Cache";
/** Control the location of the config.json files containing your feature flags and settings within the ConfigCat CDN. */
export var DataGovernance;
(function (DataGovernance) {
    /** Select this if your feature flags are published to all global CDN nodes. */
    DataGovernance[DataGovernance["Global"] = 0] = "Global";
    /** Select this if your feature flags are published to CDN nodes only in the EU. */
    DataGovernance[DataGovernance["EuOnly"] = 1] = "EuOnly";
})(DataGovernance || (DataGovernance = {}));
var OptionsBase = /** @class */ (function () {
    function OptionsBase(apiKey, clientVersion, options, defaultCache) {
        var _a;
        this.configFileName = "config_v5";
        this.logger = new ConfigCatConsoleLogger(LogLevel.Warn);
        this.requestTimeoutMs = 30000;
        this.baseUrlOverriden = false;
        this.proxy = "";
        if (!apiKey) {
            throw new Error("Invalid 'apiKey' value");
        }
        if (!defaultCache) {
            defaultCache = new InMemoryCache();
        }
        this.apiKey = apiKey;
        this.clientVersion = clientVersion;
        this.dataGovernance = (_a = options === null || options === void 0 ? void 0 : options.dataGovernance) !== null && _a !== void 0 ? _a : DataGovernance.Global;
        this.cache = defaultCache;
        switch (this.dataGovernance) {
            case DataGovernance.EuOnly:
                this.baseUrl = "https://cdn-eu.configcat.com";
                break;
            default:
                this.baseUrl = "https://cdn-global.configcat.com";
                break;
        }
        if (options) {
            if (options.logger) {
                this.logger = options.logger;
            }
            if (options.requestTimeoutMs) {
                if (options.requestTimeoutMs < 0) {
                    throw new Error("Invalid 'requestTimeoutMs' value");
                }
                this.requestTimeoutMs = options.requestTimeoutMs;
            }
            if (options.baseUrl) {
                this.baseUrl = options.baseUrl;
                this.baseUrlOverriden = true;
            }
            if (options.proxy) {
                this.proxy = options.proxy;
            }
            if (options.cache) {
                this.cache = options.cache;
            }
            if (options.flagOverrides) {
                this.flagOverrides = options.flagOverrides;
            }
        }
    }
    OptionsBase.prototype.getUrl = function () {
        return this.baseUrl + "/configuration-files/" + this.apiKey + "/" + this.configFileName + ".json" + "?sdk=" + this.clientVersion;
    };
    OptionsBase.prototype.getCacheKey = function () {
        return "js_" + this.configFileName + "_" + this.apiKey;
    };
    return OptionsBase;
}());
export { OptionsBase };
var AutoPollOptions = /** @class */ (function (_super) {
    __extends(AutoPollOptions, _super);
    function AutoPollOptions(apiKey, sdkType, sdkVersion, options, defaultCache) {
        var _this = _super.call(this, apiKey, sdkType + "/a-" + sdkVersion, options, defaultCache) || this;
        /** The client's poll interval in seconds. Default: 60 seconds. */
        _this.pollIntervalSeconds = 60;
        /** You can subscribe to configuration changes with this callback. */
        _this.configChanged = function () { };
        /** Maximum waiting time between the client initialization and the first config acquisition in seconds. */
        _this.maxInitWaitTimeSeconds = 5;
        if (options) {
            if (options.pollIntervalSeconds !== undefined && options.pollIntervalSeconds !== null) {
                _this.pollIntervalSeconds = options.pollIntervalSeconds;
            }
            if (options.configChanged) {
                _this.configChanged = options.configChanged;
            }
            if (options.maxInitWaitTimeSeconds !== undefined && options.maxInitWaitTimeSeconds !== null) {
                _this.maxInitWaitTimeSeconds = options.maxInitWaitTimeSeconds;
            }
        }
        if (_this.pollIntervalSeconds < 1) {
            throw new Error("Invalid 'pollIntervalSeconds' value");
        }
        if (_this.maxInitWaitTimeSeconds < 0) {
            throw new Error("Invalid 'maxInitWaitTimeSeconds' value");
        }
        return _this;
    }
    return AutoPollOptions;
}(OptionsBase));
export { AutoPollOptions };
var ManualPollOptions = /** @class */ (function (_super) {
    __extends(ManualPollOptions, _super);
    function ManualPollOptions(apiKey, sdkType, sdkVersion, options, defaultCache) {
        return _super.call(this, apiKey, sdkType + "/m-" + sdkVersion, options, defaultCache) || this;
    }
    return ManualPollOptions;
}(OptionsBase));
export { ManualPollOptions };
var LazyLoadOptions = /** @class */ (function (_super) {
    __extends(LazyLoadOptions, _super);
    function LazyLoadOptions(apiKey, sdkType, sdkVersion, options, defaultCache) {
        var _this = _super.call(this, apiKey, sdkType + "/l-" + sdkVersion, options, defaultCache) || this;
        /** The cache TTL. */
        _this.cacheTimeToLiveSeconds = 60;
        if (options) {
            if (options.cacheTimeToLiveSeconds) {
                _this.cacheTimeToLiveSeconds = options.cacheTimeToLiveSeconds;
            }
        }
        if (!_this.cacheTimeToLiveSeconds || _this.cacheTimeToLiveSeconds < 1) {
            throw new Error("Invalid 'cacheTimeToLiveSeconds' value. Value must be greater than zero.");
        }
        return _this;
    }
    return LazyLoadOptions;
}(OptionsBase));
export { LazyLoadOptions };
